module.exports = __webpack_public_path__ + "img/source03_m6.44fb460a.png";